import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

// Alpine components
import accordion from './alpine/accordion.js'
import accordionSingle from './alpine/accordion--single.js'
import hero from './alpine/hero.js'
import nav from './alpine/nav.js'
import overlap from './alpine/overlap.js'
import tabs from './alpine/tabs.js'
import testimonialHeads from './alpine/testimonial--heads.js'
import video from './alpine/video.js'
import wheel from './alpine/wheel.js'

// Initialise alpine plugins
Alpine.plugin(collapse)
Alpine.plugin(focus)

// Initialise alpine components
Alpine.data('accordion', accordion)
Alpine.data('accordionSingle', accordionSingle)
Alpine.data('hero', hero)
Alpine.data('nav', nav)
Alpine.data('overlap', overlap)
Alpine.data('tabs', tabs)
Alpine.data('testimonialHeads', testimonialHeads)
Alpine.data('video', video)
Alpine.data('wheel', wheel)

// Initialise alpine
window.Alpine = Alpine
Alpine.start()

// Open Offsite Links and PDFs in New Tab
let links = [...document.links].forEach((link) => {
    if (link.hostname != window.location.hostname) {
        link.target = '_blank'
        link.rel = 'noopener noreferrer'
    }
})
